let petitionLinks = {
    raiseTheDegree : {
        title: 'Raise The Degree',
        desc: 'Derek M Chauvin is a Minneapolis police officer who killed George Floyd on Memorial day. May 25, 2020. Raise the degree. This is first degree murder. People of color will not be silenced by this system any longer.',
        link: 'https://www.change.org/p/minneapolis-district-attorney-raise-the-degree?recruiter=1098599238&utm_source=share_petition&utm_medium=twitter&utm_campaign=psf_combo_share_initial&utm_term=psf_combo_share_abi&recruited_by_id=960efe90-a206-11ea-8907-8fc7af712ec3'
    },
    defundThePolice : {
        title: 'Defund The Police',
        desc: 'We call for a national defunding of police. We demand investment in our communities and the resources to ensure Black people not only survive, but thrive. If you’re with us, add your name to the petition right now and help us spread the word.',
        link: 'https://blacklivesmatter.com/defundthepolice/'
    },
    colorOfChange : {
        title: 'Color Of Change',
        desc: 'This is a step in the right direction to hold the officers accountable for murdering George Floyd but more action must be taken. We are calling for further action from Mayor Jacob Frey and County Attorney Freeman.',
        link: 'https://act.colorofchange.org/sign/justiceforfloyd_george_floyd_minneapolis'
    },
    weCantBreathe : {
        title: '#WeCantBreathe',
        desc: 'The four officers have been terminated by the Minneapolis Police Department -- but this is not enough. We are demanding the attention of Hennepin County District Attorney Mike Freeman and the immediate arrest and second degree murder charge of all four officers involved in this senseless and merciless killing.  ',
        link: 'https://www.wecantbreathenational.org/'
    },
    naacpldf : {
        title: 'NAACP LDF',
        desc: 'Site that has many resources for donating and petitions to sign.',
        link: 'https://www.naacpldf.org'
    },
    breonnaTaylor : {
        title: 'Justice For Breonna Taylor',
        desc: 'Breonna Taylor was an award-winning EMT and model citizen. She loved her family and community. She worked at two hospitals as an essential worker during the pandemic. One month ago, a division of the Louisville Police Department performed an illegal, unannounced drug raid on her home. Not a single officer announced themselves before ramming down her door and firing 22 shots, shooting Breonna 8 times, killing her. ',
        link: 'http://chng.it/zkKLRTryG6',
    },
    AhmuadArbery : {
        title: 'Justice For Ahmaud Arbery',
        desc: 'Ahmuad was taking his morning jog in his neighborhood in Georgia and came a cross a white father and son who shot and killed him for taking a jog. There is video footage of this cold blooded murder but, the father and son who murdered an innocent man are walking free because one of them used to be a cop.',
        link: 'https://www.change.org/p/human-rights-campaign-justice-for-ahmuad-arbery',
    },
    runWithMaud : {
        title: 'Run With Maud',
        desc: 'He was out for a jog when he was chased down, shot, and killed by two white supremacists. We must demand the justice he deserves. ',
        link: 'https://www.runwithmaud.com/',
    },
    justiceForSean : {
        title: 'Justice For Sean',
        desc: 'This is Sean. He was a victim of police brutality that happened May 6th, 2020. He was running from the police and was on Facebook live. The police officer tased him while he was going down and then shot the man 14 times in the back. Police brutality is real! This was in Indianapolis, Indiana. They’re already investigating the shooting.',
        link: 'https://www.change.org/p/white-house-justice-for-sean?recruiter=69572427&utm_source=share_petition&utm_medium=twitter&utm_campaign=psf_combo_share_initial&utm_term=psf_combo_share_abi&recruited_by_id=a4411689-1113-4cc7-b38b-2457ccedf381'
    },
    justiceForMatthew : {
        title: 'Justice For Mattthew Tucker',
        desc: 'Matthew Tucker was murdered by two Riverside police officers, Rosa Calderon and Michael Hamilton, in Temecula on May 4th, 2016.',
        link: 'http://chng.it/LbN2KqvHNT'
    },
    justiceEmerald : {
        title: 'Justice For Emerald Black',
        desc: 'Because of the abhorrent attacks done by the police, Ms. Black suffered not only physical, but emotional injuries. She lost her unborn child.',
        link: 'http://chng.it/5YMPRqg4mV'
    },
    fireJared : {
        title: 'Fire Jared Campbell',
        desc: 'Very recently, a video was released of a little kid screaming after getting maced by an officer named Jared Campbell. He is part of the Seattle Police Department and has a badge number of 8470.',
        link: 'http://chng.it/DJhDKWhHqG'
    },
    elijah : {
        title: 'Justice For Elijah McClain',
        desc: 'Sign this petition to bring justice for Elijah. Demand that these officers are held accountable.',
        link: 'http://chng.it/StcFzRKt76'
    },
    kadijah : {
        title: 'Justice For Kadijah M. Saccoh',
        desc: '"I am demanding justice for my 5 year old cousin Kadijah Saccoh. Kadijah was a U.S. citizen who was brutally raped, tortured, and strangled to death in Sierra Leone, a country on the coast of West Africa."',
        link: 'http://chng.it/kzTTxXmDDm'
    },
    cornelius : {
        title: 'Justice For Cornelius! Shut Sequel Down',
        desc: 'Last week, 16-year-old Cornelius Fredericks died after being restrained for throwing a sandwich at Lakeside Academy in Kalamazoo, MI, which is run by the national for-profit company Sequel Youth and Family Services.',
        link: 'http://chng.it/hD7P2sNt6x'
    },
    jamal : {
        title: 'Justice For Jamal Williams',
        desc: 'Jamal Williams, 22, a recent college graduate and football star from Western Michigan UniversityJamal Williams, was shot to death by a retired police officer while seeking help for anxiety.',
        link: 'http://chng.it/xTQLGyDhmn'
    },
    tete : {
        title: 'Justice For TETE',
        desc: 'Tete Gulley was a 31 year old queer Black transient. She was also known by some of her family as Otis. She was found hanging from a tree on the evening of May 27th 2019 in Rocky Butte Park. The cause of death was determined to be suicide at the scene but there is evidence of foul play. ',
        link: 'http://chng.it/zDrXj7Mgtp'
    },
    darriusStewart : {
        title: 'Justice For Darrius Stewart',
        desc: '19 year old Darrius Stewart lost his life in 2015 by a police officer In Memphis in a case of mistaken identity. He was completely unarmed.',
        link: 'http://chng.it/Y9dFSr7sQv'
    },
    dafonteMiller : {
        title: 'Justice For Dafonte Miller',
        desc: 'Dafonte Miller was 19, when he was chased down by what we now know to be two police officers, Michael & Christian Thériault. ',
        link: 'http://chng.it/ZK7C88dmX9'
    },
}

export default petitionLinks;